import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, TextInput, Dimensions, TouchableOpacity } from 'react-native';
import * as SVG from 'react-native-svg';
import toTitleCase from '@hooks/toTitleCase';
import { useDispatch } from 'react-redux';
import * as Animatable from 'react-native-animatable';
import { CHANGE_ITEM_DATA_TITLE, CHANGE_ITEM_DATA_TYPE } from '@reduxLocal/actions/types';
import DropDownPicker from 'react-native-dropdown-picker';
import dataTypes from '../utils/dataTypes';
import globalStyles from '@stylesheet';
import { Entypo, MaterialIcons } from "@expo/vector-icons";
import ExamplePreviewHandler from './elements/ExamplePreviewHandler';
import parseByDelimiter from '@utils/parseByDelimiter';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { useDeviceType } from '@hooks/useDeviceType';

interface PreviewComponent {
  visible?: boolean,
  dataField?: any,
  indexLength: number,
  currentIndex: number,
  interaction?: boolean,
  toolbarRef?: any
}


const PreviewComponent = ({ visible, dataField, indexLength, currentIndex, interaction }: PreviewComponent) => {
  const theme = themeSelector();
  const { isTablet } = useDeviceType();
  const [dataType, setDataType] = useState('');
  const [selected, setSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [dataTypeField, setDataTypeField] = useState(null);
  const [items, setItems] = useState(dataTypes);
  const [categoryOpen, setCategoryOpen] = useState(false)
  const dispatch = useDispatch();

  const [options, setOptions] = useState(false);

  const openArrow = () => { return (<View style={{ alignSelf: 'center' }}><Entypo name={"chevron-thin-up"} style={{ alignSelf: 'center', alignContent: 'center', alignItems: 'center' }} size={10} color={theme ? '#1e293b' : '#f1f5f9'} ></Entypo></View>) }
  const closeArrow = () => { return (<Entypo name={"chevron-thin-down"} style={{ alignSelf: 'center', alignContent: 'center', alignItems: 'center' }} size={10} color={theme ? '#1e293b' : '#f1f5f9'} ></Entypo>) }

  useEffect(() => {
    if (dataField != null) {
      setDataType(Object.keys(dataField)[0])
    }
  }, [dataField])


  const onDataTypeOpen = useCallback(() => {
    setCategoryOpen(false);
  }, [])

  const handleDataTypeChange = (value) => {
    console.log(value)
    // setDataTypeField(value.value)
    dispatch({
      type: CHANGE_ITEM_DATA_TYPE, payload: {
        index: currentIndex, newValue: {
          data: value.data,
          dataCategory: value.dataCategory,
          headers: value.headerField,
          key: value.key,
          dataTypes: value.value
        }
      }
    })
  }

  return (
    <Animatable.View useNativeDriver animation={'fadeIn'} delay={currentIndex * 100} style={{ flex: 1, flexDirection: 'row', padding: isTablet ? 20 : 16, alignSelf: 'stretch', left: -50 }}>
      <View style={{ top: 40 }}>
        <SVG.Svg width={100} height={100} style={{ flex: 1, marginRight: -20, marginTop: -40 }}>
          <SVG.Circle cx={10} cy={10} r={5} scale={3} stroke={'rgba(59, 130, 246, 0.3)'} strokeWidth={2} fill={!selected ? (theme ? 'white' : '#1e293b') : '#3b82f6'} />
        </SVG.Svg>
        {
          visible ?
            <View >
              <SVG.Svg width={100} height={100} style={{ flex: 1, marginRight: -20 }}>
                <SVG.Circle cx={10} cy={10} r={5} scale={3} stroke={'rgba(59, 130, 246, 0.3)'} strokeWidth={2} fill={theme ? 'white' : '#1e293b'} />
              </SVG.Svg>
            </View>
            :
            null
        }
        <>
          <SVG.Svg width={100} height={'120%'} style={{ flex: 1, position: 'absolute', left: 25, zIndex: -1 }}>
            <SVG.Defs>
              <SVG.LinearGradient id="uniqueLineGradient" x1="0" x2="0" y1="0" y2="1">
                <SVG.Stop offset={'0%'} stopColor={'#3b82f6'} />
                <SVG.Stop offset={'30%'} stopColor={'rgba(59, 130, 246, 0)'} stopOpacity={0} />
              </SVG.LinearGradient>
            </SVG.Defs>
            {
              currentIndex > indexLength - 2 ?
                null
                :
                <SVG.Rect id={'Somenewid'} width={10} height={Dimensions.get('window').height} fill={"url(#uniqueLineGradient)"} />
            }
          </SVG.Svg >
        </>
      </View>
      <View style={{ flex: 1 }}>
        {
          interaction &&
          <View style={{ flex: 1, flexDirection: 'row', position: 'absolute', top: -15, left: 100, zIndex: -5 }}>
              <View style={{
                backgroundColor: '#3b82f6',
                borderTopEndRadius: 50,
                borderTopStartRadius: 50,
                minWidth: isTablet ? 300 : 250,
                minHeight: isTablet ? 60 : 50,
                padding: 10,
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <Text style={{ color: 'white', fontWeight: '600', fontSize: isTablet ? 14 : 13 }}>Label</Text>
            </View>
              <View style={{
                backgroundColor: '#3b82f6',
                borderTopEndRadius: 50,
                borderTopStartRadius: 50,
                minWidth: isTablet ? 400 : 300,
                minHeight: isTablet ? 60 : 50,
                padding: 10,
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <Text style={{ color: 'white', fontWeight: '600', fontSize: isTablet ? 14 : 13 }}>Type</Text>
            </View>
          </View>
        }
        <View style={{ flex: 1, minWidth: 230 }}>
          <View style={{ flex: 1, flexDirection: 'row', marginBottom: 40, overflow: 'visible' }}>
            <View style={{ zIndex: -1, flex: 1, borderRadius: 2, marginRight: -30, transform: [{ rotateZ: '45deg' }], backgroundColor: '#3b82f6', maxHeight: 15, maxWidth: 15, left: -20, top: 23, shadowRadius: 20, shadowOpacity: .2 }} />
            <Animatable.View
              transition={'height'}
              style={[
                globalStyles.modernCard,
                theme ? globalStyles.modernBgLight : globalStyles.modernBgDark,
                {
                  padding: isTablet ? 12 : 10,
                  paddingHorizontal: isTablet ? 18 : 15,
                  flex: 5,
                  height: options ? (isTablet ? 200 : 180) : (isTablet ? 90 : 80),
                  borderRadius: 16,
                  overflow: 'visible',
                  borderLeftWidth: 3,
                  borderLeftColor: '#3b82f6'
                }
              ]}
            >
              <View style={{ flexDirection: 'row', alignContent: 'stretch', gap: isTablet ? 30 : 20, alignSelf: 'stretch', overflow: 'hidden' }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flex: 2 }}>
                  <MaterialIcons name="label-outline" size={isTablet ? 18 : 16} color="#3b82f6" />
                  <TextInput
                    value={parseByDelimiter(dataField?.title)}
                    editable={interaction ? interaction : false}
                    onChangeText={(v) => {
                      setDataType(v);
                      dispatch({ type: CHANGE_ITEM_DATA_TITLE, payload: v, index: currentIndex })
                    }} 
                    style={{
                      top: -10,
                      flex: 1,
                      fontWeight: '600',
                      padding: isTablet ? 20 : 16,
                      maxWidth: 300,
                      fontSize: isTablet ? 15 : 14,
                      color: theme ? '#1e293b' : '#f1f5f9'
                    }}
                    placeholderTextColor={theme ? '#94a3b8' : '#64748b'}
                  />
                </View>
                {
                  interaction &&
                  <DropDownPicker
                    style={{
                      zIndex: 10000,
                      flex: 3,
                      paddingHorizontal: 10,
                      borderRadius: 8,
                      overflow: 'visible',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      borderWidth: 1,
                      borderColor: theme ? '#e2e8f0' : '#334155',
                      backgroundColor: theme ? '#f8fafc' : '#1e293b',
                      alignContent: 'center',
                      alignItems: 'center',
                      maxWidth: 350
                    }}
                    value={dataTypeField}
                    setValue={setDataTypeField}
                    onSelectItem={(value) => { handleDataTypeChange(value) }}
                    open={open}
                    showArrowIcon={true}
                    setItems={setItems}
                    onOpen={onDataTypeOpen}
                    dropDownContainerStyle={{
                      flex: 1,
                      borderWidth: 1,
                      borderColor: theme ? '#e2e8f0' : '#334155',
                      backgroundColor: theme ? 'white' : '#1e293b',
                      opacity: 1,
                      zIndex: 500000,
                      flexDirection: 'row',
                      minHeight: 150,
                      maxHeight: options ? 300 : 80
                    }}
                    arrowIconStyle={{ backgroundColor: theme ? 'white' : '#1e293b' }}
                    ArrowDownIconComponent={openArrow}
                    ArrowUpIconComponent={closeArrow}
                  arrowIconContainerStyle={{ flex: 1, alignSelf: 'auto' }}
                  containerStyle={{ flex: 1, maxHeight: 50 }}
                    items={dataTypes}
                    dropDownDirection={'BOTTOM'}
                    setOpen={setOpen}
                    textStyle={{ fontSize: isTablet ? 11 : 10, color: theme ? '#1e293b' : '#f1f5f9', fontWeight: '500' }}
                    autoScroll={false}
                  />
                }
              </View>
                 
            </Animatable.View>
          </View>
          {
            selected &&
            <Animatable.View
              useNativeDriver
              animation={'fadeInDown'}
              style={[
                globalStyles.modernCard,
                theme ? globalStyles.modernBgLight : globalStyles.modernBgDark,
                {
                  gap: 10,
                  marginBottom: 40,
                  borderWidth: 2,
                  borderColor: '#3b82f6',
                  borderRadius: 16,
                  zIndex: -10,
                  overflow: 'hidden'
                }
              ]}
            >
              <View style={{
                backgroundColor: '#3b82f6',
                paddingHorizontal: 16,
                paddingVertical: 8,
                flexDirection: 'row',
                alignItems: 'center',
                gap: 8
              }}>
                <MaterialIcons name="preview" size={18} color="white" />
                <Text style={{
                  color: 'white',
                  fontSize: isTablet ? 14 : 13,
                  fontWeight: '600'
                }}>
                  Preview
                </Text>
              </View>
              <View style={{
                flex: 1,
                padding: isTablet ? 16 : 12,
                justifyContent: 'center',
                alignContent: 'center'
              }}>
                <View style={{
                  margin: 10,
                  flexDirection: 'row',
                  minWidth: '100%',
                  alignItems: 'center',
                  gap: 12
                }}>
                  <Text
                    adjustsFontSizeToFit
                    style={{
                      flex: 2,
                      minWidth: 70,
                      fontSize: isTablet ? 15 : 14,
                      fontWeight: '600',
                      color: theme ? '#1e293b' : '#f1f5f9'
                    }}
                  >
                    {toTitleCase(dataField?.title || '')}
                  </Text>
                  <View style={{ flex: 5 }}>
                    <ExamplePreviewHandler componentType={dataField.type} defaultValue={null} parameters={{}} />
                  </View>
                </View>
              </View>
            </Animatable.View>
          }
        </View>
      </View>
    </Animatable.View >
  )
}
export default PreviewComponent;